import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedServicesService } from '../shared/sharedservices/shared-services.service';
import { ResourceDto } from '../Models/ResourceDto';
import { LoginService } from '../landing/login.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-user-not-allowed-error',
  templateUrl: './user-not-allowed-error.component.html',
  styleUrls: ['./user-not-allowed-error.component.scss'],
  encapsulation: ViewEncapsulation.None, // to enable styles in innerHTML
})
export class UserNotAllowedErrorComponent implements OnInit {
  resource: ResourceDto;
  msgSubscription: Subscription;
  errorMessage: string = '';
  // `<div style="text-align: center; margin-top: 30px;" class="accessError">
  //   <p>
  //     <img src="../../assets/images/Maintenance.JPG" height="200px" alt="Maintenance">
  //   </p>
  //   <p style="font-size: 32px;" class="errorHeading">
  //     Scheduled Maintenance
  //   </p>
  //   <p style="font-size: 18px;" class="errorText">
  //     Due to scheduled maintenance activities, MERA Web and Mobile App will not be available
  //     <br />from 30-Jun-2023 06:00 GMT to 10-July-2023 6:00 GMT.
  //     <br /><br />Apologies for the inconvenience caused.
  //   </p>
  // </div>`;

  constructor(
    public sharedService: SharedServicesService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.resource = new ResourceDto();
    // refresh Header & Footer
    this.sharedService.setHeaderDetails(this.resource);
    this.sharedService.setFooterDetails(this.resource);
    this.loginService.setMenuHideAndShow(false);

    this.errorMessage = sessionStorage.getItem('WhitelistError');
    if (!this.errorMessage) {
      this.getStaticContent();
    }
    else {
      sessionStorage.removeItem('WhitelistError');
    }
  }
  
  getStaticContent() {
    this.msgSubscription = this.sharedService
      .getStaticContent('WhitelistError')
      .subscribe((data: any) => {
        this.errorMessage = data.body.customData.contentValue;
      });
  }
}
